import $ from 'jquery';
import { AdaSupport } from '../../components/modules/ada-support';

$(window).on('load', () => {
  const container = $('.audio-player');
  const audioNames = $('.audio-player__name--desktop');
  const audioItemsDesktop = $('.audio-player__item--desktop');
  const audioItemsMobile = $('.audio-player__item--mobile');
  const playBtns = $('.audio-player__play');
  const playText = 'Play Audio';
  const stopText = 'Stop Audio';
  audioItemsDesktop.first().addClass('active');
  audioItemsMobile.first().addClass('active');
  audioNames.on('click', function () {
    const desktopItem = $(this).closest('.audio-player__item--desktop');
    const idx = audioItemsDesktop.index(desktopItem);
    audioItemsDesktop.removeClass('active');
    audioItemsMobile.removeClass('active');
    audioItemsDesktop.eq(idx).addClass('active');
    audioItemsMobile.eq(idx).addClass('active');
    document.querySelectorAll('audio').forEach((el) => el.pause());
    playBtns.text(playText);
  });

  playBtns.on('click', function () {
    // eslint-disable-next-line
    if ($(window).width() < breakpoints.tablet) {
      document.querySelectorAll('audio').forEach((el) => el.pause());
    }

    if (!$(this).hasClass('play')) {
      $(this).addClass('play').text(stopText);
      this.nextElementSibling.play();
    } else {
      $(this).removeClass('play').text(playText);
      this.nextElementSibling.pause();
    }
  });

  AdaSupport(audioNames);
  const { hash } = window.location.hash;
  if (hash && container.find(hash).length) {
    setTimeout(() => {
      const trackItemDesktop = audioItemsDesktop.filter(hash);
      const idx = audioItemsDesktop.index(trackItemDesktop);
      audioItemsDesktop.removeClass('active');
      audioItemsMobile.removeClass('active');
      trackItemDesktop.addClass('active');
      audioItemsMobile.eq(idx).addClass('active');

      $('html, body').animate({
        scrollTop: container.offset().top - 50,
      }, 500);
    }, 500);
  }
});
